import { render, staticRenderFns } from "./DrawSignature_v2.vue?vue&type=template&id=79154138"
import script from "./DrawSignature_v2.vue?vue&type=script&lang=js"
export * from "./DrawSignature_v2.vue?vue&type=script&lang=js"
import style0 from "./DrawSignature_v2.vue?vue&type=style&index=0&id=79154138&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports